export default __webpack_public_path__ + "static/media/logo.98cad806.png";